import { render } from "./SupplierUserEditMenu.vue?vue&type=template&id=529706de&scoped=true"
import script from "./SupplierUserEditMenu.vue?vue&type=script&lang=js"
export * from "./SupplierUserEditMenu.vue?vue&type=script&lang=js"

import "./SupplierUserEditMenu.vue?vue&type=style&index=0&id=529706de&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-529706de"]])

export default __exports__